import userData from './userData';
import tilesData from './tilesData';
import demoData from './demoData';
import organizationData from './organizationData';
import progressBarData from './progressBarData';
import editPage from './editPage';
import tilesPerRow from './tilesPerRow';
import status from './status';
import tiles from './tiles';
import dndContext from './dndContext';
import clients from './clients';

export default {
  userData,
  tilesData,
  demoData,
  organizationData,
  progressBarData,
  editPage,
  tilesPerRow,
  status,
  tiles,
  dndContext,
  clients,
};
